import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedDate, FormattedTime, FormattedMessage, injectIntl} from "react-intl";

// @mui/material components
import {
    Button,
    Avatar,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
} from "@mui/material"

// @mui/icons-material
import {
    NotificationsActive,
    Add,
    EmojiPeople,
} from "@mui/icons-material";

// core components
import BeatLoaderRegular from "components/loaders/BeatLoaderRegular";
import CancellationReasonDialog from "views/picking/components/cancellationReasonDialog";
import LineItemActivity from "views/picking/components/lineItemActivity";
import PriceDetails from 'views/picking/components/PriceDetails';
import TableCard from "./components/tableCard";
import Snackbar from "components/snackbar/snackbar";

// styles
import showStyle from "assets/jss/views/picking/order/showStyle";

// actions
import {list, reset} from "actions/lineItem/list";
import {
    cancellationReason,
    reset as resetUpdateOrder
} from "actions/order/update";
import {list as noteList, reset as noteReset} from "actions/order/note/list";
import {list as lineItemActivityList, reset as lineItemActivityReset} from "actions/order/lineItemActivity/list";
import {create as createNote} from "actions/order/note/create";
import {resetUpdate} from "actions/lineItem/update";
import {list as organizationShippingMethodsList} from "api/shippingMethod/list";

// helpers
import {capitalize} from "utils/capitalize";
import abort from "utils/abort";
import {Authorizations, hasAuthorization} from "utils/authorizations";

// context
import {OrderContext} from "contexts/OrderContext";
import {withStyles} from "@mui/styles";

class Show extends Component {
    static propTypes = {
        error: PropTypes.string,
        list: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            createErrorNotification: true,
            modalOpen: false,
            trackingNumber: null,
            runner: false,
            addNoteOpen: false,
            note: null,
            organizationShippingMethods: [],
            cancellationReasonDialog: false,
            transitionActions: null,
            selectedItem: null,
            lineItemSelectedIds: [],
            waitingTimeBeforeRefreshingList: false,
            selectedShipment: null,
            shouldResetSelection: false,
        };
    };

    // because we don't want to use redux to trigger a refresh
    refreshOrder(waitingTime = 0) {
        this.setState({
            waitingTimeBeforeRefreshingList: true,
            shouldResetSelection: true,
            lineItemSelectedIds: [],
            selectedShipment: null,
        });
        setTimeout(() => {
            this.props.list(decodeURIComponent(`order.id=${this.props.match.params.id}&pagination=true&itemsPerPage=9999&page=1&order[name]=asc`));
            this.props.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
            this.props.lineItemActivityList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
            this.props.resetUpdate();
            this.props.resetUpdateOrder();
            this.setState({
                waitingTimeBeforeRefreshingList: false,
                shouldResetSelection: false,
            });
        }, waitingTime);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({createErrorNotification: true});
        if ((this.props.updateSuccessOrder !== nextProps.updateSuccessOrder) || this.props.updateSuccessLineItem !== nextProps.updateSuccessLineItem) {
            this.refreshOrder();
        }

        if (this.props.noteCreated !== nextProps.noteCreated) {
            nextProps.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
        }
    }

    componentDidMount() {
        this.props.list(decodeURIComponent(`order.id=${this.props.match.params.id}&pagination=true&itemsPerPage=9999&page=1&order[name]=asc`));
        this.props.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
        this.props.lineItemActivityList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));

        organizationShippingMethodsList().then((res) => {
            this.setState({
                organizationShippingMethods: res
            })
        })
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.noteReset();
        this.props.lineItemActivityReset();
        abort.abortRequests();
    };

    toggleModalWaybillSelector = () => {
        this.setState({
            modalOpen: !this.state.modalOpen,
        });
    }

    handleMoreClick = () => {
        this.setState(state => ({
            open: !state.open,
        }));
    };

    confirmCancellationAction(reason, unavailableDays = null) { const {selectedItem} = this.state;
        this.props.cancellationReason(selectedItem, reason, unavailableDays);

        this.closeCancellationReasonDialog();
    }

    openCancellationDialogByTransitionAndItem(order, transitionActions) {
        this.setState({
            selectedItem: order,
            transitionActions: transitionActions,
            cancellationReasonDialog: true
        })
    }

    closeCancellationReasonDialog() {
        this.setState({
            cancellationReasonDialog: false,
            selectedItem: null,
            transitionActions: null
        })
    }

    setLineItemSelectedIds = (lineItemIds) => {
        this.setState({
            lineItemSelectedIds: lineItemIds,
        })
    }

    setSelectedShipment = (shipment) => {
        this.setState({
            selectedShipment: shipment
        })
    }

    render() {
        const {classes, retrieved, loading} = this.props;

        const hasErrors = this.props.error || this.props.updateErrorOrder;
        const order = retrieved && retrieved["hydra:member"][0].order;

        const handleClickOpenAddNote = () => {
            this.setState(state => ({addNoteOpen: true}));
        };

        const handleCloseAddNote = () => {
            this.setState(state => ({addNoteOpen: false}));
        };

        const handleNoteChange = (event) => {
            this.setState({note: event.currentTarget.value});
        }

        const handleAddNote = () => {
            this.setState(state => ({addNoteOpen: false}));
            this.props.createNote({content: this.state.note, order: `/orders/${order.id}`, member: `/members/${this.props.member.id}`})
        };

        const isRefreshing = loading && retrieved;

        const loaderOverlay = isRefreshing ? (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 1000,
                borderRadius: '4px'
            }}>
                <BeatLoaderRegular loading={loading} />
            </div>
        ) : null;

        if (loading && !retrieved) {
            return (
                <div className={classes.containerWithSidebar}>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px', width: '100%'}}>
                        <BeatLoaderRegular loading={loading} />
                    </div>
                </div>
            )
        }

        return (
            <div className={classes.containerWithSidebar}>
                {hasErrors && (
                    <Snackbar
                        open={this.state.createErrorNotification}
                        close
                        closeNotification={() => this.setState({createErrorNotification: false})}
                        place={"bl"}
                        color={"danger"}
                        icon={function () {
                            return <NotificationsActive/>
                        }}
                        message={this.props.error}
                    />
                )}
                <div className={classes.container}>
                    {loaderOverlay}
                    <TableCard 
                        order={order}
                        state={this.state}
                        openCancellationDialogByTransitionAndItem={(order, transitionActions) => this.openCancellationDialogByTransitionAndItem(order, transitionActions)}
                        toggleModalWaybillSelector={this.toggleModalWaybillSelector}
                        refreshOrder={(waitingTime) => this.refreshOrder(waitingTime)}
                        match={this.props.match}
                        setSelectedShipment={this.setSelectedShipment}
                        setLineItemSelectedIds={this.setLineItemSelectedIds}
                        shouldResetSelection={this.state.shouldResetSelection}
                    />
                    <div className={classes.priceDetailsContainer}>
                        {loaderOverlay}
                        <PriceDetails
                            lineItems={this.props.retrieved && this.props.retrieved['hydra:member']}
                            currentOrganization={this.props.currentOrganization}
                            authorizations={this.props.authorizations}
                        />
                    </div>
                    {!this.props.noteLoading && !this.props.lineItemActivityLoading &&
                        <div>
                            {!hasAuthorization(this.props.authorizations, Authorizations.PICKING_READ_ONLY) &&
                                <div className={classes.addNoteContainer}>
                                    <Button color="primary" onClick={handleClickOpenAddNote} endIcon={<Add/>}>
                                        <FormattedMessage id={'picking.order.show.note.add'}/>
                                    </Button>
                                    <Dialog open={this.state.addNoteOpen} onClose={handleCloseAddNote} aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title">
                                            <FormattedMessage id={"picking.order.show.note.dialog.title"}/>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText>
                                                <FormattedMessage id={"picking.order.show.note.dialog.content"}/>
                                            </DialogContentText>
                                            <TextField
                                                variant="standard"
                                                autoFocus
                                                margin="dense"
                                                id="name"
                                                type="text"
                                                fullWidth
                                                onChange={handleNoteChange} />
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseAddNote} color="primary">
                                                <FormattedMessage id={"picking.order.show.dialog.action.cancel"}/>
                                            </Button>
                                            <Button onClick={handleAddNote} color="primary">
                                                <FormattedMessage id={"picking.order.show.dialog.action.confirm"}/>
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </div>
                            }


                            {((this.props.noteRetrieved && this.props.noteRetrieved["hydra:member"].length > 0) || (this.props.lineItemActivityRetrieved && this.props.lineItemActivityRetrieved["hydra:member"].length > 0)) &&
                                this.renderNotesAndLineItemActivities()
                            }
                        </div>
                    }
                </div>
                <OrderContext.Provider value={{
                    closeCancellationReasonDialog: () => this.closeCancellationReasonDialog(),
                    confirmCancellationAction: (selectedReason, daysCount) => {
                        this.confirmCancellationAction(selectedReason, daysCount)
                    },
                    isCancellationReasonDialogOpen: this.state.cancellationReasonDialog,
                    transitionActions: this.state.transitionActions,
                    isOrderAllowed: true,
                    isItemAllowed: false,
                    status: this.state.selectedItem?.status
                }}>
                    <CancellationReasonDialog />
                </OrderContext.Provider>
            </div>
        );
    }

    renderNotesAndLineItemActivities() {
        const {classes} = this.props;

        let items = [];
        // Hotfix because we have async problem with those 2 fields
        if (this.props.noteRetrieved) {
            items = this.props.noteRetrieved["hydra:member"] ?? [];
        }
        if (this.props.lineItemActivityRetrieved) {
            items = items.concat(this.props.lineItemActivityRetrieved["hydra:member"] ?? []);
        }

        items.sort((itemA, itemB) => {
            let dateA = Date.parse(itemA.createdAt), dateB = Date.parse(itemB.createdAt);
            return (dateA < dateB) - (dateA > dateB);
        });

        return items.map((item, key) => {
            let content;
            let user;
            switch (item['@type']) {
                case 'Note':
                    user = item.member ? item.member.user : null;
                    content = this.renderNote(item);
                    break;
                case 'LineItemActivity':
                    user = item.user;
                    content = <LineItemActivity classes={classes} lineItemActivity={item} />
                    break;
                default:
                    console.warning('Try to render an invalid object of type ' + item['@type'] + '. Supported types : Note, LineItemActivity.');
                    return <></>;
            }

            return (
                <div className={classes.noteContainer} key={key}>
                    {user ?
                        <div>
                            {user.picture ?
                                <img
                                    src={user.picture}
                                    className={classes.img}
                                    alt={""}
                                />
                                :
                                <Avatar className={classes.imgPlaceholder}>
                                    {capitalize(user.familyName.charAt(0) + user.givenName.charAt(0))}
                                </Avatar>
                            }
                        </div>
                        :
                        <Avatar className={classes.imgPlaceholder}>
                            <EmojiPeople/>
                        </Avatar>
                    }
                    <Paper className={classes.notePaper} elevation={0} variant="outlined">
                        <div className={classes.notePaperHeader}>
                            <span>{user ? user.givenName + ' ' + user.familyName : this.props.intl.formatMessage({id: "picking.order.show.note.customer"})}</span>
                            <span><FormattedDate value={new Date(item.createdAt)}/> - <FormattedTime value={new Date(item.createdAt)}/></span>
                        </div>
                        {content}
                    </Paper>
                </div>
            );
        });
    }

    renderNote(note) {
        let content = this.translateAffectedCommandNote(note.content)
        content = this.translateAffectedArticleNote(content)

        return (
            <p>{content}</p>
        )
    }

    translateAffectedCommandNote(content) {
        const regex = /Je me suis affecté la commande: #(.*)/g
        const matches = regex.exec(content)
        if (matches) {
            content = <FormattedMessage
                id={'picking.order.show.note.affected_command'}
                values={{orderId: matches[1]}}
            />
        }

        return content
    }

    translateAffectedArticleNote(content) {
        const regex = /Je me suis affecté l'article: (.*)/g
        const matches = regex.exec(content)
        if (matches) {
            content = <FormattedMessage
                id={'picking.order.show.note.affected_article'}
                values={{lineItemName: matches[1]}}
            />
        }

        return content
    }
}

const mapStateToProps = state => {
    return {
        retrieved: state.lineItem.list.retrieved,
        loading: state.lineItem.list.loading,
        error: state.order.list.error,
        noteRetrieved: state.note.list.retrieved,
        noteLoading: state.note.list.loading,
        noteCreated: state.note.create.created,
        lineItemActivityRetrieved: state.lineItemActivity.list.retrieved,
        lineItemActivityLoading: state.lineItemActivity.list.loading,
        updateSuccessOrder: state.order.update.success,
        updateErrorOrder: state.order.update.error,
        updateSuccessLineItem: state.lineItem.update.success,
        member: state.authentication.member,
        authorizations: state.authentication.authorizations,
        currentOrganization: state.currentOrganization.retrieved ?? null,
    };
};

const mapDispatchToProps = dispatch => ({
    list: params => dispatch(list(params)),
    noteList: params => dispatch(noteList(params)),
    lineItemActivityList: params => dispatch(lineItemActivityList(params)),
    createNote: values => dispatch(createNote(values)),
    reset: () => dispatch(reset()),
    noteReset: () => dispatch(noteReset()),
    lineItemActivityReset: () => dispatch(lineItemActivityReset()),
    resetUpdate: () => dispatch(resetUpdate()),
    resetUpdateOrder: () => dispatch(resetUpdateOrder()),
    cancellationReason: (order, reason, unavailableDays) => dispatch(cancellationReason(order, reason, unavailableDays))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(showStyle)(injectIntl(Show)));
